<template>
	<div id="app" view="app" extension-name="app">

		<div a_id="login-page-logo-container" class="login-page-logo-container">
			<div a_id="login-page-logo-center" class="login-page-logo-center"/>
		</div>

		<keep-alive>
			<component :is="currentPage"
					   v-model="currentPage"
					   @accountChanged="updateCurrentAccountId"
					   :currentAccountId="currentAccountId"
					   class="page-container"
					   @notify="notify"></component>
		</keep-alive>

		<notification-popup
				:title="notificationTitle"
				:message="notificationMessage"
				v-model="notificationShow"
				v-show="notificationShow"/>
	</div>
</template>

<script>
	import LoginSignInPage from './LoginSignInPage.vue';
	import LoginMFAPage from './LoginMFAPage.vue';
	import ForgotPasswordPage from './ForgotPasswordPage.vue';
	import EditPasswordPage from './EditPasswordPage.vue';
	import NotificationPopup from './NotificationPopup.vue';
	import LogoutPage  from './LogoutPage.vue';

	export default {
		name: 'InteractLogin',
		data () {
			return {
				currentPage: "LoginSignInPage",
				currentAccountId: '',
				notificationTitle: '',
				notificationMessage: '',
				notificationShow: false
			}
		},
		components: {
			LoginSignInPage,
			LoginMFAPage,
			ForgotPasswordPage,
			EditPasswordPage,
			NotificationPopup,
			LogoutPage
		},
		mounted(){
			let path = window.location.href;
			debugger;
			if(path.indexOf("change-password") > -1 || path.indexOf("reset-password") > -1){
				this.currentPage = "EditPasswordPage";
			} else if (path.indexOf('logout') > -1) {
				this.currentPage = "LogoutPage";
			}

			detectBrowser();
		},
		methods: {
			updateCurrentAccountId(currentAccountId){
				this.currentAccountId = currentAccountId;
			},
			notify(title, message){
				this.$nextTick(() => {
					this.notificationTitle = title;
					this.notificationMessage = message;
					this.notificationShow = true;
				})
			}
		},
		watch : {
			notificationShow(){
				console.log("notificationShow: " + this.notificationShow)
			}
		}
	}


	function detectBrowser() {
		var ua = navigator.userAgent,
			doc = document.documentElement;

		if ((ua.match(/MSIE 10.0/i))) {
			doc.className = doc.className + " ie10";

		} else if ((ua.match(/rv:11.0/i))) {
			doc.className = doc.className + " ie11";
		}
	}

</script>

<style lang="scss">
	@import "../sass/measurements";

	[view="app"] {


		.page-container{
			display: inline-block;
			width: 400px;
			margin-top: calc(50vh - #{$form-height/2});
			margin-left: $page-left-margin;
		}

	}

</style>



// WEBPACK FOOTER //
// src/app/App.vue